module.exports = __webpack_public_path__ + "static/img/noFriend.fcc5d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/home/noFriend.png
// module id = Je/j
// module chunks = 0